export const useProductSelect = ({ formData = {}, setFormData = () => {} }) => {
  const handleCheckBoxUpdate = (idKey) => {
    if (!formData?.is_select_all)
      return setFormData((prev) => {
        const exists = prev.selected_ids.includes(idKey);

        return {
          ...prev,
          selected_ids: exists
            ? prev.selected_ids.filter((id) => id !== idKey)
            : [...prev.selected_ids, idKey],
        };
      });

    setFormData((prev) => {
      const exists = prev.exclude_selected_ids.includes(idKey);

      return {
        ...prev,
        exclude_selected_ids: exists
          ? prev.exclude_selected_ids.filter((id) => id !== idKey)
          : [...prev.exclude_selected_ids, idKey],
      };
    });
  };

  const handleCheckAll = (itemList) => {
    setFormData((prev) => ({
      ...prev,
      is_select_all: !formData?.is_select_all,
      selected_ids: [],
      exclude_selected_ids: [],
    }));
  };

  return { handleCheckBoxUpdate, handleCheckAll };
};
